<template>
  <div v-if="theme" class="body edit-theme">
    <div class="tb-form-group">
      <label class="tb-label">Title</label>

      <input
        class="tb-input"
        type="text"
        :value="title"
        data-entity="producer-editor-themeTitle"
        data-test="display-editor-title"
        @keyup.right.stop
        @keyup.left.stop
        @input="setTitle"
      />
    </div>

    <!-- Only show controls once theme settings are loaded -->
    <div
      v-if="isLoading"
      class="loading loading--inline"
    >
      <i class="fas fa-spinner fa-spin"></i>
    </div>

    <component
      v-else
      :is="item.layout"
      :item="item"
      :theme="theme"
      :editing="editing"
    />
  </div>
</template>

<script>
import IsolatedComponent from './themes/Isolated.vue';
import CinematicComponent from './themes/Cinematic.vue';
import CarouselComponent from './themes/Carousel.vue';
import GridComponent from './themes/Grid.vue';
import LowerThirdComponent from './themes/LowerThird.vue';
import LowerThirdScrollComponent from './themes/LowerThirdScroll.vue';
import MuralComponent from './themes/Mural.vue';
import StoriesComponent from './themes/Stories.vue';
import TickerComponent from './themes/Ticker.vue';
import WaterfallComponent from './themes/Waterfall.vue';

export default {
  components: {
    isolated: IsolatedComponent,
    cinematic: CinematicComponent,
    carousel: CarouselComponent,
    grid: GridComponent,
    lowerthird: LowerThirdComponent,
    lowerthirdscroll: LowerThirdScrollComponent,
    mural: MuralComponent,
    stories: StoriesComponent,
    ticker: TickerComponent,
    waterfall: WaterfallComponent,
  },

  props: {
    editing: {
      type: Object,
      required: true,
    },

    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isLoading() {
      return this.$store.state.themes.isLoadingMap[this.theme._id];
    },

    theme() {
      return this.$store.state.themes.lookupTable[this.item._id];
    },

    title() {
      return this.item?.title || this.theme?.title || '';
    },

    currentLayoutIndex() {
      return this.$store.state.production.production.index;
    },

    isCurrentLayout() {
      return this.item && (this.item.timeline_id === this.currentLayoutIndex);
    },

    currentSampleLayoutIndex() {
      return this.$store.state.preview.production.index;
    },

    isCurrentSampleLayout() {
      return this.item && (this.item.timeline_id === this.currentSampleLayoutIndex);
    },
  },

  methods: {
    sendUpdate() {
      this.$store.dispatch('updateTimeline', { force: true });
    },

    sendSampleUpdate() {
      this.$store.dispatch('updatePreviewTimeline', { force: true });
    },

    setTitle($event) {
      this.$store.dispatch('setTimelineTitle', {
        timelineId: this.editing?.timeline_id,
        title: $event.target.value,
      });

      // Debounce send over the socket.
      // Otherwise we'll send a message every character, which is annoying.
      clearTimeout(this.updateTimeout);
      this.updateTimeout = setTimeout(() => {
        this.$store.dispatch('updateTimeline');
        this.$store.dispatch('updatePreviewTimeline');
      }, 500);
    },
  },
};
</script>
